import './FrontB.sass';
import heroL from '../assets/hero/front-b-l.jpg';
import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';

const FrontBTrophy = () => {
	return (
		<div className='FrontB'>
			<Hero data={[{ pic: heroL, description: '大華資產管理' }]} />

			<Breadcrumbs
				data={[
					{ url: '', name: '麵包屑', guid: 'a' },
					{ url: '', name: '麵包屑', guid: 'b' },
				]}
			/>

			<div className='common-pad-wrap'>
				<div className='content'>
					<div className='customized advantage'>
						<div className='icon-title'>
							<div className='icon'>
								<img src='/assets/about-us/icon-chess.svg' alt='' />
							</div>

							<div className='text'>大華資產管理的企業使命與成功優勢</div>
						</div>

						<img src='/assets/about-us/advantage1-l.jpg' alt='' className='l' />
						<img src='/assets/about-us/advantage1-m.jpg' alt='' className='m' />

						<div className='award'>
							<div className='img'>
								<img src='/assets/about-us/advantage-award.png' alt='AsianInvestor ASSET MANAGEMENT AWARDS 2021' />
							</div>

							<div className='text'>Asia Fund House of the Year,2021,2020,2019</div>
						</div>

						<p>
							新加坡向來以「嚴謹」、「穩健」著稱，我們常打趣的說，新加坡政府有鞭刑的刑責，在新加坡的資產管理公司也會拿著鞭子鞭策基金經理人，因此我們擁有最嚴謹的投資策略，以及極高的執行效率，而位在高速成長的亞洲市場，新加坡大華資產管理站在絕佳的戰略位置上，語言優勢更成為我們掌握華人市場的關鍵，在歐美系基金公司為主的市場中，我相信華人重感情的專業服務、與新加坡人重紀律的投資策略，地利優勢使我們更接近這塊市場，深入了解投資人的需求。
						</p>

						<p>大華資產管理公司(UOBAM)是亞洲領先的資產管理公司，在管理固定收益和股票投資組合方面擁有屢獲殊榮的投資專業知識。我們成立於1986年，是大華銀行的全資子公司，現已發展成為亞洲資產管理行業中的的區域強勢品牌。</p>

						<p>
							總部位於新加坡，我們在亞洲擁有廣泛且不斷增長的業務，在馬來西亞、泰國、汶萊、日本、台灣、中國大陸、印尼及越南設有地區辦事處。我們的網絡包括大華另類投資管理有限公司(新加坡)，大華伊斯蘭資產管理有限公司(馬來西亞)，我們與中國的平安信託合資成立了平安基金管理公司(中國)，以及日本的三井住友資產管理成立了UOB-SM
							DS資產管理公司(新加坡)。此外，我們還與UTI International(印度)和新加坡Wellington(威靈頓)管理公司建立了策略聯盟。
						</p>

						<p>我們由90多名經驗豐富的投資專家組成的團隊在成熟的投資框架內進行嚴格的基礎研究，為客戶提供創新的投資解決方案。我們團隊的實力在於我們對卓越投資的承諾，自1986年以來，我們的表現已得到業界的認可，並獲得了292多個獎項。</p>

						<p>我們致力於將環境、社會和治理(簡稱ESG)等可持續發展因素納入投資考量，並且己於2020年1月2日成為大華銀行旗下三家簽署聯合國負責任投資原則(United Nations supported Principles for Responsible Investment, UNPRI)子公司之一，這同時也是新加坡第一家簽署UNPRI的金融集團。</p>

						<p>負責任的維持增長是我們可持續發展戰略的核心目標之一，我們不僅重視負責任投資,也承諾會朝可持續性金融業務方向實踐。大華資產管理做為有關原則簽署方，自2017年以來便將ESG列為投資研究，證券評估和批准流程的考量因素，公司借由穩妥風險管理來為投資者創建可持續性長期回報。</p>

						<p>透過我們的區域網絡，我們為個人、機構和公司提供全球投資管理專業知識。我們提供全面的產品組合，包括零售單位信託(Unit Trust)、交易所交易基金(ETFs)以及為機構客戶量身定制的投資組合管理服務。 我們管理的資產(包括子公司)總額約為370億新幣。</p>

						<div className='sec-sub'>大華資產管理致力於卓越投資</div>

						<div className='sub2'>我們的願景:</div>

						<p>成為亞洲值得信賴的資產管理公司，引領創新和永續發展</p>

						<div className='sub2'>我們的策略支柱:</div>

						<img src='/assets/about-us/advantage2-l.jpg' alt='' className='l' />
						<img src='/assets/about-us/advantage2-m.jpg' alt='' className='m' />

						<div className='sub-title'>事實與數據</div>

						<div className='li'>
							<img className='dot' src='/assets/dot.svg' alt='' />
							<div className='text'>超過30年的投資經驗</div>
						</div>

						<div className='li'>
							<img className='dot' src='/assets/dot.svg' alt='' />
							<div className='text'>約377億新幣的管理資產</div>
						</div>

						<div className='li'>
							<img className='dot' src='/assets/dot.svg' alt='' />
							<div className='text'>自1986年以來已獲得292多個獎項</div>
						</div>

						<div className='li'>
							<img className='dot' src='/assets/dot.svg' alt='' />
							<div className='text'>90多名專業投資專家團隊</div>
						</div>

						<div className='li'>
							<img className='dot' src='/assets/dot.svg' alt='' />
							<div className='text'>遍布9個亞洲市場</div>
						</div>

						<p>
							您可點選&nbsp;
							<a href='https://www.uobam.com.sg/about-us/index.page' target='_blank' rel='noreferrer noopener'>
								{' '}
								https://www.uobam.com.sg/about-us/index.page{' '}
							</a>
							&nbsp;獲得更多大華資產管理的介紹!
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FrontBTrophy;
